import React from 'react';
import classNames from 'classnames';
import ModalAction from '@/components/ModalAction';
import LoaderIcon from '@/images/icons/Loader';
import { useFormHandler } from '@/hooks/useFormHandler';
import { PlanForm } from '@/components/Form/PlanForm';

const EditPlanModal = ({ modalOpen, setModalOpen, modalError, submitCallback, plan }: any) => {
	const onClearModal = () => {
		setModalOpen(false);
	};

	const onSubmit = async (e: any) => {
		setModalOpen(false);
		submitCallback(e);
	}

	const {
		formData,
		formReset,
		isLoading,
		formRef,
		onFieldChange,
		onSave,
	} = useFormHandler<any>(plan, onSubmit, onClearModal);

	return (
		<ModalAction
			id="edit-subscription-modal"
			modalOpen={modalOpen}
			setModalOpen={setModalOpen}
			onModalClose={() => onClearModal()}
			size={undefined}
		>
			<div className="h2 mb-8 md:mb-10">
				Edit Plan
			</div>
			<PlanForm
				formData={formData}
				onFieldChange={onFieldChange}
				onSave={onSave}
				formReset={formReset}
				isLoading={isLoading}
				formRef={formRef}
				plan={plan}
			/>
			{modalError && (
				<div className="text-sm text-red-orange mt-2 font-medium">{modalError}</div>
			)}
			<button className={classNames(
				`btn-primary w-full mt-8`,
				!isLoading && 'hidden',
			)}>
				<div className="flex items-center justify-center py-1 pointer-events-none">
					<LoaderIcon className="animate-rotation w-6 h-6 text-white" />
				</div>
			</button>
		</ModalAction>
	);
};

export default EditPlanModal;
